import RadioInput from './RadioInput';
import RadioGroup from './RadioGroup';

export default {
  Input: RadioInput,
  InputGroup: RadioGroup
};
